module.exports = __webpack_public_path__ + "img/file33.d6fac027.png";